import { render } from "./MewAddressSelect.vue?vue&type=template&id=5f15173e&scoped=true&ts=true"
import script from "./MewAddressSelect.vue?vue&type=script&lang=ts"
export * from "./MewAddressSelect.vue?vue&type=script&lang=ts"

import "./MewAddressSelect.vue?vue&type=style&index=0&id=5f15173e&lang=scss&scoped=true"
import "./MewAddressSelect.vue?vue&type=style&index=1&id=5f15173e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f15173e"]])

export default __exports__